<template>
    <div>
        <div class="card">
            <div class="data-area lg-20 sm-100">
                <div class="info">
                    <h3 class="full-size">
                        <font-awesome-icon
                            :icon="isActive ? 'bolt' : 'moon'"
                            style="font-size: 1.3em"
                        />
                    </h3>
                    <h3 class="lg-100 md-33 sm-100">
                        <div>Heute</div>
                        {{tagesenergie}} kWh
                    </h3>
                    <h3 class="lg-100 md-33 sm-50">
                        <div>Aktuelle Leistung</div>
                        {{aktuelleLeistung}} W
                    </h3>
                    <h3 class="lg-100 md-33 sm-50">
                        <div>Gesamtleistung</div>
                        {{gesamtLeistung}} kWh
                    </h3>
                    <!-- <h3>
                        <div>{{lastUpdate.format("DD.MM. HH:mm")}}</div>
                    </h3>-->
                </div>
            </div>
            <div class="chart lg-80 sm-100">
                <LoadingSpinner class="spinner" v-if="loading" />
                <TotalDataGraph class="chart" @update="onDataUpdate" :date="selectedDate" />
            </div>
            <div class="day-selector sm-100">
                <button @click="previousDay">&lt;</button>
                <input type="date" v-model="selectedDate" :max="todayDateString()" />
                <button @click="nextDay" :disabled="selectedDate === todayDateString()">&gt;</button>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import TotalDataGraph from "@/components/TotalDataGraph";
import moment from "moment";

export default {
    name: "home",
    data: function() {
        return {
            lastUpdate: moment("1970-01-01"),
            tagesenergie: 0,
            aktuelleLeistung: 0,
            gesamtLeistung: 0,
            isActive: false,
            loading: true,
            selectedDate: moment().format("YYYY-MM-DD")
        };
    },
    watch: {
        selectedDate: function() {
            this.$data.loading = true;
        }
    },
    components: {
        TotalDataGraph,
        LoadingSpinner
    },
    methods: {
        onDataUpdate(data) {
            if (this.$data.loading) this.$data.loading = false;
            this.$data.lastUpdate = moment.unix(data.zeit.seconds);
            this.$data.tagesenergie = data.tagesenergie;
            this.$data.aktuelleLeistung = data.aktuelleLeistung;
            this.$data.gesamtLeistung = data.gesamtLeistung;
            this.$data.isActive = data.aktuelleLeistung > 0;
        },
        nextDay() {
            this.$data.selectedDate = moment(this.$data.selectedDate)
                .add(1, "day")
                .format("YYYY-MM-DD");
        },
        previousDay() {
            this.$data.selectedDate = moment(this.$data.selectedDate)
                .subtract(1, "day")
                .format("YYYY-MM-DD");
        },
        todayDateString() {
            return moment().format("YYYY-MM-DD");
        }
    }
};
</script>

<style scoped>
.card {
    background-color: #fff;
    margin: 1em auto;
    width: 90%;
    height: 80%;
    padding: 15px;
    box-shadow: 2px 2px 5px #666;
    border-radius: 1px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.card > .data-area {
    display: flex;
    justify-content: center;
}

.info > h3 {
    color: #464d55;
    font-weight: normal;
    font-size: 1em;
    font-family: sans-serif;
    margin-left: 0;
}

.info > h3 > div {
    font-size: 0.8em;
}

.info > h2 {
    margin: auto;
    display: inline;
}

.info {
    padding: 50px 0;
    display: flex;
    flex-wrap: wrap;
}

.chart {
    width: 100%;
    margin: auto;
    height: 270px;
}

.full-size {
    width: 100%;
}

.day-selector > * {
    margin: 0 0.2em;
    height: 2em;
}

@media only screen and (min-width: 769px) {
    .lg-100 {
        width: 100%;
    }

    .lg-20 {
        width: 20%;
    }

    .lg-80 {
        width: 80%;
    }
}

@media only screen and (max-width: 768px) {
    .card {
        height: 80%;
    }

    .info {
        flex-wrap: wrap;
        width: 100%;
        padding: 12px 0;
    }

    .md-33 {
        width: 33.33%;
    }
}

@media only screen and (max-width: 350px) {
    .info {
        width: 100%;
        padding: 12px 0;
    }

    .sm-50 {
        width: 50%;
    }

    .sm-100 {
        width: 100%;
    }
}

.spinner {
    position: relative;
    top: 100px;
    height: 0%;
}
</style>
